<template>
    <div>
      <CRow>
        <CCol sm="12" md="12">
          <CCard accent-color="primary">
            <CCardHeader
              class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
            >
              Ver Bono aplicado Folio:{{folio}}
              <div>
                <router-link :to="{
                        name: 'EditBonoAplicado',
                        params: {
                          folio: folio,
                          config: config
                        }
                      }">
                  <CButton color="success" class="mr-1 btn-header">
                    <CIcon class="mr-1" name="cil-pencil" />Editar
                  </CButton>
                </router-link>
                <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                  <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                  <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
                </CButton>
                <BackButton :to="{ name: 'BonoAplicado', params: { config: config } }">
                  <CButton color="primary" class="mr-1 btn-header">
                    <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                  </CButton>
                </BackButton>
              </div>
            </CCardHeader>
  
            <CCardBody v-if="isLoading">
              <div class="w-100 d-flex justify-content-center align-items-center">
                <div class="sk-flow">
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                  <div class="sk-flow-dot bg-primary"></div>
                </div>
              </div>
            </CCardBody>
  
            <CCardBody v-else>
              <CCol sm="12" class="text-right">
                {{ this.item.author.correo }}
              </CCol>
              <CRow>
                 <CCol sm="12" md="9" lg="9">
                  <label>Fecha:</label>
                  <CInput v-model="date" disabled type="date" :horizontal="{ input: 'col-sm-12' }" />
                </CCol>
              </CRow>
  
              <CRow>
                <CCol>
                  <label>Trabajador:</label>
                  <CInput
                    v-model="trabajador"
                    disabled
                    horizontal
                  />
                </CCol>
              </CRow>
  
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <label>Ubicaciones:</label>
                  <div class="d-flex margin-multi align-items-center">
                    <MultiSelectC
                      v-model="multi"
                      :options="ubicaciones"
                      :multiple="true"
                      label="label"
                      disabled
                      :loading="isLoading"
                      track-by="label"
                      placeholder="Selecciona uno o varias ubicaciones"
                    >
                      <template #no-options>Sin resultados.</template>
                    </MultiSelectC>
                  </div>
                </CCol>
              </CRow>
  
              <CRow>
                 <CCol sm="12" md="9" lg="9">
                  <label>Fecha inical:</label>
                  <CInput v-model="dateInit" disabled type="date" :horizontal="{ input: 'col-sm-12' }" />
                </CCol>
              </CRow>
              <CRow>
                 <CCol sm="12" md="9" lg="9">
                  <label>Fecha final:</label>
                  <CInput v-model="dateEnd" disabled type="date" :horizontal="{ input: 'col-sm-12' }" />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <CInput
                    :value.sync="concepto"
                    :label="`Concepto: `"
                    disabled
                    placeholder="Concepto..."
                    type="text"
                  />
                </CCol>
              </CRow>
  
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <CInput
                    :value.sync="monto"
                    :label="`Monto: `"
                    placeholder="Monto..."
                    type="number"
                    disabled
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <label>Comentarios:</label>
                  <CTextarea v-model="comentarios" disabled horizontal />
                </CCol>
              </CRow>
  
              <CRow>
                <CCol sm="9">
                  <label>Tipo de costo:</label>
                  <CInput v-if="tipo_costo" v-model="tipo_costo.label" disabled :horizontal="{ input: 'col-sm-12' }" />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12" md="9" lg="9">
                  <KlayFileDD
                    :fetching="fetching"
                    v-model="medias"
                    :label="`Anexos: `"
                    @onFetch="onFetch"
                    @onErrorFetch="(err)=>{
                      fetching=false;
                      error=err
                      warningModal=true
                    }"
                    :fetchMethod="pushMedia"
                    :baseSrc="$store.getters.MediaGet"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                  <i class="fa fa-spinner fa-pulse"></i>
                </CButton>
                <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                  <span>Actualizar</span>
                </CButton>
              </CRow>
              <CModal
                size="sm"
                title="Bono"
                :centered="true"
                color="warning"
                :show.sync="warningModal"
              >{{ error }}</CModal>
              <CModal
                size="sm"
                title="Bono"
                :centered="true"
                color="success"
                :show.sync="successModal"
                >Guardado con éxito.
                <template #footer>
                  <CButton @click="successModal = false"  color="success">Aceptar</CButton>
                </template>
              </CModal>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </div>
  </template>
  
  <script>
  
  export default {
    name: "VerBonoAplicado",
  
    components: {
    },
  
    data() {
      return {
        folio: this.$route.params.id,
        config: this.$route.params.config,
        semanas: 1,
        dateInit : '',
        dateEnd : '',
        concepto: "",
        monto: 1,
        item: {},
        date: null,
        dateInitial: null,
        multi: null,
        trabajador: null,
        trabajadores: [],
        trabajadoresAll: [],
        categoria: null,
        categorias: [],
        categoriasAll: [],
        actividad: null,
        actividades: [],
        actividadesAll: [],
        ubicacion: null,
        ubicaciones: [],
        ubicacionesAll: [],
        isLoading: false,
        tiempo_extra: false,
        isFijo: false,
        comentarios: '',
        successModal: false,
        warningModal: false,
        error: "",
        tipo_costo: null,
        tiposCosto:[{ value: 'cosecha', label: 'Cosecha' },{ value: 'no_cosecha', label: 'No cosecha' }],
        isLoadingPage: false,
        currentAlertCounter: 0,
        fetching: false,
        medias:[],
        loader: false,
        
      };
    },
  
    computed: {
      ubicacionRaiz() {
        return this.$store.state.rootLocation
          ? this.$store.state.rootLocation.value
          : "";
      }
    },
  
    created() {
      this.isLoading = true;
  
      const ubi = [
        this.$store.dispatch("customDocumentoHTTP", {
          schema: "bonos_aplicados",
          filter: {
            wherein: [
              {
                field: "payload->encabezado->ubicacion_raiz_id",
                value: [this.ubicacionRaiz]
              }
            ],
            where: [
              {
                field: "folio",
                value: this.folio,
                operator: "="
              }
            ]
          },
          ["with-storage"] : ["*"]
        })
      ];
  
  
  
      // ubi.push(ubicacionTemplateNoRaiz);
  
      Promise.all(ubi)
        .then(([item]) => {
  
          this.item = item.data[0];
          this.trabajador = this.item.payload.encabezado._relaciones.trabajador.payload.nombre;
          this.concepto = this.item.payload.encabezado.concepto;
          this.monto = this.item.payload.encabezado.monto;
          this.dateInit = this.item.payload.encabezado.fecha_inicial;
          this.dateEnd = this.item.payload.encabezado.fecha_final;
          this.comentarios = this.item.payload.encabezado.comentarios;
          this.medias = this.item.payload.anexos;
          this.tipo_costo = this.tiposCosto.find(f=>f.value == this.item.payload.encabezado.tipo_costo);
  
          const newMult = this.item.payload.encabezado._relaciones.ubicacion
              .filter(ubi => ubi.id)
              .map(ubicacion => {
                return { value: ubicacion.id, label: ubicacion.payload.nombre };
              });
          this.multi = newMult;
  
          let dateDocto = new Date(this.item.payload.encabezado.fechahora);
  
          let year = dateDocto.getFullYear();
          let month = ("0" + (dateDocto.getMonth() + 1)).slice(-2);
          let day = ("0" + dateDocto.getDate()).slice(-2);
  
          this.date = `${year}-${month}-${day}`;
        })
        .finally(() => (this.isLoading = false));
    },
  
    methods: {
      getReporte(){
        if(this.loader){
          return
        }
        this.loader = true
        this.$forceUpdate();
        const reportCall = {
          reporte: "formato_bonos_aplicados",
          params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
          pdf : true
        };
  
        // console.log(reportCall);
        // call.push(reportCall);
  
        
          this.$store.dispatch("reportsPDFHttp", {
            ...reportCall
          }).then(res => {
  
            const blob = res;
  
            let a = document.createElement("a");
            a.style = "display: none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "Reporte de bonos aplicados.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })
  
          .finally(() => {
            this.loader = false
            this.$forceUpdate();
          });
      },
      async onFetch(medias){
        this.fetching=false
        const {folio,serie,schema,payload} = this.item
        const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
        body.payload.anexos = medias
        delete body.payload.encabezado._relaciones
        this.$store.dispatch("customDocumentoRemplazarHTTP",body)
          .then(()=>{
            this.currentAlertCounter = 6;
              // console.log(res.data);
              // this.$router.push({ name: "Produccion" });
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
            this.fetching=false
            return;
          })
  
          .finally(() => {
            this.fetching=false
            if (!this.warningModal) {
              this.successModal = true;
            }
          });
        
      },
      async pushMedia(files) {
        const arr = [];
        
        for (const v of files.map(async (m) => {
          // eslint-disable-next-line no-extra-boolean-cast
          if(!!m.media){
            return Promise.resolve({data:m,status:"success"})
          }
          const formData = new FormData();
          formData.append("media", m);
          const promise = await this.$store.dispatch("customImageHTTP", formData);
  
          return promise;
        })) {
          const media = await v;
          if (media.status === "success") {
            arr.push(media.data);
          }
        }
        return arr;
        /*
          const formData = new FormData()
          formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
          this.$store.dispatch('MEDIA_CARGAR', formData)
        */
      },
    }
  };
  </script>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style src="spinkit/spinkit.min.css"></style>
  
  <style scoped>
  .catalogo-text {
    font-size: 1.2rem !important;
  }
  .line {
    color: #321fdb; /* old IE */
    background-color: #321fdb; /* Modern Browsers */
  }
  @media (max-width: 420px) {
    .btn-header {
      padding-left: 8px;
      padding-right: 8px;
      font-size: 12px;
    }
    .padding-sm {
      padding-left: 10px;
      padding-right: 10px;
    }
    .text-sm {
      font-size: 11px !important;
    }
    .margin-sm {
      margin: 5px;
    }
  }
  </style>
  
  